import React, { useState, Fragment } from 'react';
import { string, arrayOf, object, bool, number } from 'prop-types';
import { useSelector } from 'react-redux';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Lang from '../../../components/language/services/Lang';
import Skeleton from '../../../components/library/loaders/Skeleton';
import { toast, Slide } from 'react-toastify';
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader';
import FilingStatusRow from '../../diy-return/components/FilingStatusRow';
import FilingStatusSummary from '../../diy-return/components/FilingStatusSummary';
import ReturnStatusIcon from '../../diy-return/components/ReturnStatusIcon';
import ReturnStatusLabel from '../../diy-return/components/ReturnStatusLabel';


const FilingStatusCard = props => {
    const { type, returns, isCollapsed, isRefile} = props
    const lang = useSelector(state => state.layout.lang)
    const [collapsed, setCollapsed] = useState(isCollapsed)  

    const getFilingStatus = (type) => {        
        var refileType = ''
        var alternateType = ''
        var alternateRefileType=''
        if (type === 'CRA') {
            refileType = 'REFILECRA'            
            alternateType = 'EFILE'
            alternateRefileType = 'PROREFILE'
        }
        if (type === 'RQ') {
            refileType = 'REFILEMRQ'
            alternateType = 'EFILEMRQ'
            alternateRefileType = 'PROREFILEMRQ'
        }

        if (type === 'T1135') {
            refileType = 'REFILET1135'
            alternateType = 'EFILET1135'
        }

        if (type === 'EFILE')
            refileType = 'REFILECRA'

        if (type === 'EFILEMRQ')
            refileType = 'REFILEMRQ'

        let filteredReturns = returns.filter(x => x.submissiontype === type)
        if (filteredReturns.length === 0) {
            filteredReturns = returns.filter(x => x.submissiontype === alternateType)
        }
        let filteredRefileReturns = returns.filter(x => x.submissiontype === refileType)
        if (filteredRefileReturns.length === 0) {
            filteredRefileReturns = returns.filter(x => x.submissiontype === alternateRefileType)
        }
        var status = ''
        
        if (filteredReturns.length !== 0) {
            status = filteredReturns[0].status
        }  

        if (filteredRefileReturns.length !== 0) {
            status = filteredRefileReturns[0].status
        }  

        if (status !== '') {
            return { status: status }
        }
        return null  
    }   

    const getIconStatus = () => {
        let iconStatus = 'REJECT'

        var CraStatus = getFilingStatus('CRA')
        var RqStatus = getFilingStatus('RQ')
        var T1135Status = getFilingStatus('T1135')

        var successCount = 0        
        var errorCount = 0

        if (CraStatus && CraStatus.status === 'SUCCESS') {
            successCount += 1
        }
        else if (CraStatus && CraStatus.status === 'PAPERFILED') {
            successCount += 1
        }
        else if (CraStatus) {
            errorCount +=1
        }

        if (RqStatus && RqStatus.status === 'SUCCESS') {
            successCount += 1
        }
        else if (RqStatus) {
            errorCount += 1
        }

        if (T1135Status && T1135Status.status === 'SUCCESS') {
            successCount += 1
        }
        else if (T1135Status) {
            errorCount += 1
        }

        if (errorCount > 0 && successCount === 0) {
            iconStatus = 'REJECT'
        }
        if (successCount > 0 && errorCount === 0)
        {
            iconStatus = 'SUCCESS'
        }

        return iconStatus
        
    }

    const onCopyXmlClick = (data) => {
        copyToClipboard(data.xmlrequest)
        toast.success(Lang.getCurrentValue('ToastLabels.CopiedToClipboard'), { position: "bottom-left", autoClose: 5000, transition: Slide, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true });
    }

    const onCopyJsonClick = (data) => {
        const parsedJson = JSON.parse(data.viewmodelcontent);
        const formattedJson = JSON.stringify(parsedJson, null, 2);
        copyToClipboard(formattedJson)
        toast.success(Lang.getCurrentValue('ToastLabels.CopiedToClipboard'), { className: 'black-background-toast', position: "bottom-left", autoClose: 5000, transition: Slide, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true });
    }
   
    const copyToClipboard = (copyText) => {
        const el = document.createElement('textarea');
        el.value = copyText;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    const renderStatiiFor = (submissionType) => {

        let statii = returns.filter(x => x.submissiontype === submissionType)

        if (statii.length > 0) {
            return statii.map((r, i) => <FilingStatusRow key={'filingStatus' + i}
                submissionType={r.submissiontype}
                loading={!Boolean(r)}
                filingStatus={r.status}
                confirmationNumber={r.status === null ? null : r.confirmationcode}
                dateIssued={r.dashboardStatus !== "PAPERFILED" && r.status === null ? null : r.lastmodified}
                errorMessage={lang === 'en' ? r.errormessageen : r.errormessagefr}
                copyJson={false ? null : () => { onCopyJsonClick(r) }}
                copyXml={false ? null : () => { onCopyXmlClick(r) }} />
            )
        }
    }

    const title = type === 'PRIMARY' ? 'ReturnStatus.Card.PrimaryTitle' : 'ReturnStatus.Card.SpouseTitle'    

        return ( 
            <div className='stackable-section'>
                <CollapsibleCardHeader icon={<ReturnStatusIcon dashboardStatus={returns[0].status} netfileStatus={getIconStatus()} />} collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)}>                    
                    <div className='column is-8 pl-0 ml-0' >
                        {title === null || title === undefined ? <Skeleton /> :
                            <h5 className='return-status-title hnav-tabs'>
                                <Fragment><HrbTranslate text='ReturnInfo.Headers.ReturnStatus' params={{ Name: type }} />{' | ' + returns[0].returnid}</Fragment>                                                        
                            </h5>
                        }
                    </div>
                    <div className='column is-2 mt-1'>
                        <ReturnStatusLabel isRefile={isRefile} dashboardStatus={returns[0].submissiontype} isMailedIn={returns[0].status === 'PAPERFILED'} />
                    </div>
                </CollapsibleCardHeader>
                <FilingStatusSummary CRAStatus={getFilingStatus('CRA')} RQStatus={getFilingStatus('RQ') } T1135Status={getFilingStatus('T1135')} collapsed={collapsed} boldText={true} />
                    {!collapsed &&
                        <Fragment>
                            {renderStatiiFor('PROREFILE')}
                            {renderStatiiFor('PROREFILEMRQ')}
                            {renderStatiiFor('REFILECRA')}
                            {renderStatiiFor('CRA')}
                            {renderStatiiFor('EFILE')}
                            {renderStatiiFor('REFILEMRQ')}                            
                            {renderStatiiFor('RQ')}
                            {renderStatiiFor('EFILEMRQ')}
                            {renderStatiiFor('REFILET1135')}
                            {renderStatiiFor('T1135')}                            
                            {renderStatiiFor('EFILET1135')}   
                        </Fragment>
                    }
            </div>
        )          
    
}

FilingStatusCard.propTypes = {
    filer: string,
    clientName: string,
    hasAuditProtection: bool,
    returnStatii: arrayOf(object),
    isRefile: bool,
    refileIndex: number,
    isCollapsed: bool
}
export default FilingStatusCard